/** @jsx jsx */
import { jsx } from 'theme-ui'
import { graphql, Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

export const pageQuery = graphql`
query ContactQuery2($id: String!){
  markdownRemark(id: { eq: $id }) {
    id
    html
    excerpt(pruneLength: 140)
    frontmatter {
      title
      description
    }
  }
  site {
    siteMetadata {
      title
    }
  }
  allYoutubeVideo {
    totalCount
    nodes {
      title
      videoId
      localThumbnail {
        publicURL
      }
      publishedAt(formatString: "MMMM Do, YYYY")
      description
    }
  }
}
`

const Video = ({ data }) => {
  const { markdownRemark, allYoutubeVideo } = data // data.markdownRemark holds your post data
  const { frontmatter, html } = markdownRemark
  const { nodes } = allYoutubeVideo
  return (
    <Layout className="video-page">
      <SEO
        title={frontmatter.title}
        description={frontmatter.description}
      />
      <h1>{frontmatter.title}</h1>
      <div className="description" dangerouslySetInnerHTML={{ __html: html }} />
      <div className="grids col-1 sm-2 lg-3">
        {nodes.map((video, i) => {
          const videoLink = `http://www.youtube.com/watch?v=${video.videoId}`
          return <div className="paper" sx={{
            bg: 'cardBg'
          }}>
            <a href={videoLink}>
              <img class="poster" alt="" src={video.localThumbnail.publicURL} />
              <div className="card-contents">
                <h2>{video.publishedAt}</h2>
                <Link className="video-title" sx={{
                  variant: 'links.postLink'
                }}>
                  {video.title}
                </Link>
                <hr />
                <p>{video.description.substring(0, 70)}...</p>
                <div class="space"></div>
              </div>
            </a>
          </div>

        })}
      </div>

    </Layout>
  )
}

export default Video